import { Stack, Typography } from '@mui/material'
import React from 'react'

import { type IntegrationClientsResponse } from 'queries/integration-clients/use-get-integration-clients'

const ORDERED_INTEGRATION_CLIENT_SUMMARY_KEYS = [
  {
    key: 'active',
    label: 'Active'
  },
  {
    key: 'idle',
    label: 'Idle'
  },
  {
    key: 'inactive',
    label: 'Deactivated'
  }
]

export const PrivateNetworkIntegrationsSummary: React.FC<{
  integrationClients: IntegrationClientsResponse
}> = ({ integrationClients }) => {
  return (
    <Stack
      data-testid="private-network-integrations-summary"
      direction="row"
      sx={{ columnGap: 6 }}
    >
      {ORDERED_INTEGRATION_CLIENT_SUMMARY_KEYS.map(({ key, label }) => {
        const count = integrationClients[key]?.length ?? 0

        return (
          <Stack key={key} sx={{ textAlign: 'center' }}>
            <Typography variant="h6">{count}</Typography>
            <Typography variant="body1">{label}</Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}
